import { createSelector } from '@reduxjs/toolkit'

import { selectMultiExport } from './selectMultiExport'

export const selectIsMultiExportBusy = createSelector(
  selectMultiExport,
  ({ isGenerating, generatedReportsIds }) => isGenerating || generatedReportsIds.length > 0
)
